import { ObjectDb } from './object.db';
import { FolderMedicationGridItemObject, MedicationGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MedicationDb extends ObjectDb<MedicationGridItemObject> {

    public tableName: string = 'medication';

    protected override columnMap = {
        code: 'code',
    };

    protected override pageSize = 1_000;

    protected override indices = ['code'];

    protected gqlMethod = 'getMedications';

    protected override refreshOnUserChange = false;

    protected syncFragment = `
        code
        name
        nameAddition
        updatedAt
    `;

}
